import React from "react"
import PropTypes from "prop-types"
import { Heading } from "components"

const FormSection = ({
  children, title, disabled, marginTop
}) => (
  /**
   * Renders a form template
   * @param {Object} [props] - Component props object
   * @param {Node} [props.children] - Children to render inside.
   * @param {String} [props.title] - Field data to submit.
   * @returns {Component} - react form component
   */
  <div
    className="inspectlet-sensitive"
    style={{
      color: "#999",
      marginTop: marginTop || "3em",
      opacity: disabled ? 0.5 : 1,
      transform: ".3s"
    }}>
    {title && (
      <div style={{ padding: "1.5em 1em 0" }}>
        <Heading
          value={title}
          tag={"h5"}
          customHeadingStyle={{
            textAlign: "center"
          }} />
      </div>
    )}
    {children}
  </div>
)

FormSection.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
  disabled: PropTypes.bool,
  marginTop: PropTypes.string
}

export default FormSection



// WEBPACK FOOTER //
// ./src/components/forms/form-section.jsx